<template>
  <div>
    <div :class="Loading ? 'disable' : ''">
      <div class="row my-2">
        <div class="col-sm-12 col-lg-6 col-md-6">
          <label>Areas highlighted in blue need correction</label>
        </div>
        <div class="col-sm-12 col-lg-6 col-md-6 align-right">
          <b-button
            :to="{
              name: previousRoute,
            }"
            @click.native="scrollToTop"
            pill
            variant="outline-primary"
            >Return To Summary</b-button
          >
        </div>
      </div>
      <div class="row my-2">
        <div class="col-sm-12 col-lg-12 col-md-12 border p-3">
          <label>Upload User File</label>
          <div class="row my-2">
            <div
              class="col-sm-12 col-lg-12 col-md-12 border p-3"
              v-if="getUsersForPreview.length > 0"
            >
              <div
                v-for="(User, Index) in getUsersForPreview"
                :key="User.upload_id"
                class="my-3"
              >
                <label
                  >{{ User.firstname + " " + User.lastname }} (
                  {{ User.username }} ) [
                  <b-button
                    :to="{
                      name: 'AdminBatchUserUploadToolPreviewInsertUsersEdit',
                      params: {
                        uploadId: +User.upload_id,
                        previousRoute: previousRoute,
                        activeMenuItem: activeMenuItem,
                      },
                    }"
                    pill
                    size="sm"
                    variant="outline-primary"
                    >Delete</b-button
                  >
                  ]
                </label>
                <div class="row m-1">
                  <div
                    class="col-lg-2 col-md-2 border p-1"
                    v-bind:class="{
                      requiredFields: isValueTrue(FirstName[Index]),
                    }"
                  >
                    <label>First Name</label>
                    <b-form-input v-model="FirstName[Index]"></b-form-input>
                  </div>
                  <div
                    class="col-lg-2 col-md-2 border p-1"
                    v-bind:class="{
                      requiredFields: isValueTrue(LastName[Index]),
                    }"
                  >
                    <label>Last Name</label>
                    <b-form-input v-model="LastName[Index]"></b-form-input>
                  </div>
                  <div class="col-lg-2 col-md-2 border p-1">
                    <label>Middle Name</label>
                    <b-form-input v-model="MiddleName[Index]"></b-form-input>
                  </div>
                  <div
                    class="col-lg-2 col-md-2 border p-1"
                    v-bind:class="{
                      requiredFields: isValueTrue(UserName[Index]),
                    }"
                  >
                    <label>User Name</label>
                    <b-form-input v-model="UserName[Index]"></b-form-input>
                  </div>
                  <div class="col-lg-2 col-md-2 border p-1">
                    <label>Active User</label>
                    <b-form-select
                      v-model="ActiveUserYesNo[Index]"
                      :options="StatusOptionYesNo"
                    ></b-form-select>
                  </div>
                  <div class="col-lg-2 col-md-2 border p-1">
                    <label>Admin</label>
                    <b-form-select
                      v-model="IsAdminYesNo[Index]"
                      :options="StatusOptionYesNo"
                    ></b-form-select>
                  </div>
                  <div class="col-lg-2 col-md-2 border p-1">
                    <label>Single Item</label>
                    <b-form-select
                      v-model="SingleItemYesNo[Index]"
                      :options="StatusOptionYesNo"
                    ></b-form-select>
                  </div>
                  <div class="col-lg-2 col-md-2 border p-1">
                    <label>Points</label>
                    <b-form-input v-model="Points[Index]"></b-form-input>
                  </div>
                  <div class="col-lg-2 col-md-2 border p-1">
                    <label>Address</label>
                    <b-form-input v-model="Address[Index]"></b-form-input>
                  </div>
                  <div class="col-lg-2 col-md-2 border p-1">
                    <label>Address 2</label>
                    <b-form-input v-model="Address2[Index]"></b-form-input>
                  </div>
                  <div class="col-lg-2 col-md-2 border p-1">
                    <label>City</label>
                    <b-form-input v-model="City[Index]"></b-form-input>
                  </div>
                  <div class="col-lg-2 col-md-2 border p-1">
                    <label>State</label>
                    <b-form-input v-model="State[Index]"></b-form-input>
                  </div>
                  <div class="col-lg-2 col-md-2 border p-1">
                    <label>Zip</label>
                    <b-form-input v-model="Zip[Index]"></b-form-input>
                  </div>
                  <div class="col-lg-2 col-md-2 border p-1">
                    <label>Daytime Phone</label>
                    <b-form-input v-model="DaytimePhone[Index]"></b-form-input>
                  </div>
                  <div class="col-lg-2 col-md-2 border p-1">
                    <label>Evening Phone</label>
                    <b-form-input v-model="EveningPhone[Index]"></b-form-input>
                  </div>
                  <div
                    class="col-lg-2 col-md-2 border p-1"
                    v-bind:class="{
                      requiredFields: isValueTrue(Companies[Index]),
                    }"
                  >
                    <label>Company</label>
                    <b-form-select
                      v-model="Companies[Index]"
                      @change="cleanUp(Index)"
                    >
                      <option
                        v-for="company in CompanyOptions"
                        :value="company"
                        :key="company.key"
                      >
                        {{ company.text }}
                      </option>
                    </b-form-select>
                  </div>
                  <div class="col-lg-2 col-md-2 border p-1">
                    <label>Code</label>
                    <b-form-input v-model="Code[Index]"></b-form-input>
                  </div>
                  <div class="col-lg-2 col-md-2 border p-1">
                    <label>Code2</label>
                    <b-form-input v-model="Code2[Index]"></b-form-input>
                  </div>
                  <div class="col-lg-2 col-md-2 border p-1">
                    <label>Email Address</label>
                    <b-form-input v-model="EmailAddress[Index]"></b-form-input>
                  </div>
                  <div class="col-lg-2 col-md-2 border p-1">
                    <label>Social Security #</label>
                    <b-form-input v-model="SSN[Index]"></b-form-input>
                  </div>
                  <div class="col-lg-2 col-md-2 border p-1">
                    <label>Program</label>
                    <b-form-select v-model="Programs[Index]">
                      <option
                        v-for="program in clientAssociatedPrograms[
                          Companies[Index].value
                        ]"
                        :value="program"
                        :key="program.value"
                      >
                        {{ program.text }}
                      </option>
                    </b-form-select>
                  </div>
                  <div class="col-lg-2 col-md-2 border p-1">
                    <label>Transaction Comment</label>
                    <b-form-input
                      v-model="TransactionComment[Index]"
                    ></b-form-input>
                  </div>
                  <div class="col-lg-2 col-md-2 border p-1">
                    <label>Email Message</label>
                    <b-form-input v-model="EmailMessage[Index]"></b-form-input>
                  </div>
                  <div class="col-lg-2 col-md-2 border p-1">
                    <label>Email Subject</label>
                    <b-form-input v-model="EmailSubject[Index]"></b-form-input>
                  </div>
                  <div class="col-lg-2 col-md-2 border p-1">
                    <label>Joining Date</label>
                    <b-form-input v-model="JoiningDate[Index]"></b-form-input>
                  </div>
                  <div class="col-lg-2 col-md-2 border p-1">
                    <label>Birth Day</label>
                    <b-form-input v-model="BirthDay[Index]"></b-form-input>
                  </div>
                  <div class="col-lg-2 col-md-2 border p-1">
                    <label>Birth Year</label>
                    <b-form-input v-model="BirthYear[Index]"></b-form-input>
                  </div>
                </div>
              </div>
              <b-button
                class="m-2"
                @click="uploadUserFileAll()"
                pill
                variant="primary"
                >Update</b-button
              >
            </div>
            <div class="row my-2" v-else>
              <label>No Data Found</label>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="Loading === true">
      <div class="centered-spinner">
        <a-spin />
      </div>
    </div>
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import AdminSidebar from "@/views/admin/AdminSidebar.vue";
import { mapState } from "vuex";
import Modal from "@/components/Modal.vue";

export default {
  name: "BatchUserUploadToolEditRecords",

  props: {
    activeMenuItem: String,
    activeMenu: String,
    previousRoute: String,
  },

  components: {
    appHeader: Header,
    appFooter: Footer,
    appAdminSidebar: AdminSidebar,
    appModal: Modal,
  },

  data() {
    return {
      StatusOptionYesNo: [
        { value: 1, text: "Yes" },
        { value: 0, text: "No" },
      ],
      FirstName: [],
      LastName: [],
      MiddleName: [],
      UserName: [],
      NewUserName: [],
      ActiveUserYesNo: [],
      IsAdminYesNo: [],
      SingleItemYesNo: [],
      Points: [],
      Address: [],
      Address2: [],
      City: [],
      State: [],
      Zip: [],
      DaytimePhone: [],
      EveningPhone: [],
      Companies: [],
      CompanyOptions: [],
      Code: [],
      Code2: [],
      EmailAddress: [],
      SSN: [],
      Programs: [],
      ProgramName: "",
      ProgramOptions: [],
      TransactionComment: [],
      EmailMessage: [],
      EmailSubject: [],
      JoiningDate: [],
      BirthDay: [],
      BirthYear: [],
      clientAssociatedPrograms: [],
      Loading: false,
    };
  },

  methods: {
    setActiveMenuItem: function () {
      this.$store.dispatch("adminSidebar/setActive", {
        activeMenuItem: this.activeMenuItem
          ? this.activeMenuItem
          : "usersBatchUserUploadTool",
        activeMenu: this.activeMenu ? this.activeMenu : "users",
      });
    },
    scrollToTop() {
      window.scrollTo(0, 0);
    },
    getAuthorizedClientsIdsForAllProgramsList() {
      if (this.authorizedClients.length > 0) {
        var clientsIds = [];

        this.authorizedClients.forEach((client) => {
          if (typeof client.clientId === "number") {
            clientsIds.push(client.clientId);
          }
        });

        return clientsIds.join();
      }
    },
    isValueTrue: function (value) {
      if (!value) {
        return true;
      } else {
        return false;
      }
    },
    uploadUserFileAll: function () {
      this.Loading = true;
      const params = [];

      for (let i = 0; i < this.getUsersForPreview.length; i++) {
        if (
          this.UserName[i] === "" ||
          this.FirstName[i] === "" ||
          this.LastName[i] === ""
        ) {
          this.$store.dispatch("systemMessage/setModalMessage", {
            message: "Please fill the mandatory fields highlighted in blue",
          });

          return;
        }
      }

      this.getUsersForPreview.forEach((user, index) => {
        params[index] = {
          upload_id: user.upload_id,
          user_id: user.user_id === 0 ? null : parseInt(user.user_id),
          actionType: null,
          status: null,
          username: this.UserName[index],
          points: this.Points[index] === "" ? null : Number(this.Points[index]),
          singleitem: this.SingleItemYesNo[index] ? true : false,
          administrator: this.IsAdminYesNo[index],
          disabled: this.ActiveUserYesNo[index] ? true : false,
          code: this.Code[index],
          code2: this.Code2[index],
          program_id: this.Programs[index].value,
          program_Name: this.Programs[index].text,
          ssn: this.SSN[index],
          firstname: this.FirstName[index],
          lastname: this.LastName[index],
          middleinitial: this.MiddleName[index],
          address1: this.Address[index],
          address2: this.Address2[index],
          city: this.City[index],
          state: this.State[index],
          zip: this.Zip[index],
          dayphone: this.DaytimePhone[index],
          eveningphone: this.EveningPhone[index],
          email: this.EmailAddress[index],
          company_name: this.Companies[index].text,
          client_id: this.Companies[index].value,
          transaction_comments: this.TransactionComment[index],
          email_msg: this.EmailMessage[index],
          email_subject: this.EmailSubject[index],
          joining_date: this.JoiningDate[index],
          birthday: this.BirthDay[index],
          birthYear: this.BirthYear[index],
        };
      });

      this.$store
        .dispatch("adminBatchUserUploadTool/uploadUserFileAll", params)
        .then((status) => {
          this.Loading = false;
          // // update user summary
          this.$store.dispatch(
            "adminBatchUserUploadTool/fetchUserUploadSummary"
          );

          // // open message box with msg: User has been removed from the list of pending users.
          this.$store.dispatch("systemMessage/setModalMessage", {
            message: "Records updated. Check totals again",
          });

          // scrolling to top
          this.scrollToTop();

          // // at last redirect to batch user upload tool
          this.$router.push({
            name: this.previousRoute, //"AdminBatchUserUploadToolMain",
          });
        })
        .catch(() => {
          console.log("error while edit missing data upload edit records js");
        });
    },

    cleanUp(idx) {
      this.Programs[idx] = { text: "", val: 0 };
    },
  },

  computed: {
    authorizedClients() {
      return this.$store.getters["adminPointPrograms/getAuthorizedClients"];
    },
    getUsersForPreview() {
      return this.$store.getters[
        "adminBatchUserUploadTool/getAllUsersForPreview"
      ];
    },
    authorizedProgrammes() {
      return this.$store.getters["adminPointPrograms/getClientProgramsList"];
    },
    authorizedClientProgrammes() {
      return this.$store.getters[
        "adminBatchUserUploadTool/getAllClientsProgram"
      ];
    },
  },

  watch: {
    authorizedClients(authorizedClients) {
      var datas = [];
      authorizedClients.map(function (data) {
        datas.push({
          value: data.clientId,
          text: data.clientName,
        });
      });

      if (this.authorizedClients.length > 0) {
        // const clientIds = this.getAuthorizedClientsIdsForAllProgramsList();
        try {
          this.$store.dispatch("adminPointPrograms/fetchProgramsList", {
            client_ids: this.authorizedClients.map((client) => {
              return client.clientId;
            }),
          });
        } catch (error) {
          console.log(error);
        }
      }

      this.CompanyOptions = datas;
    },
    // authorizedProgrammes(authorizedProgrammes) {
    //   var datas = [];
    //   authorizedProgrammes.map(function(data) {
    //     datas.push({
    //       value: data.programId,
    //       text: data.programName,
    //     });
    //   });

    //   this.ProgramOptions = datas;
    // },
    getUsersForPreview(getUsersForPreview) {
      getUsersForPreview.forEach((user, index) => {
        this.FirstName[index] = user.firstname;
        this.LastName[index] = user.lastname;
        this.MiddleName[index] = user.middleinitial;
        this.UserName[index] = user.username;
        this.NewUserName[index] = user.new_username;
        this.ActiveUserYesNo[index] = user.disabled ? 1 : 0;
        this.IsAdminYesNo[index] = user.administrator ? 1 : 0;
        this.SingleItemYesNo[index] = user.singleitem ? 1 : 0;
        this.Points[index] = user.points;
        this.Address[index] = user.address1;
        this.Address2[index] = user.address2;
        this.City[index] = user.city;
        this.State[index] = user.state;
        this.Zip[index] = user.zip;
        this.DaytimePhone[index] = user.dayphone;
        this.EveningPhone[index] = user.eveningphone;
        this.Companies[index] = {
          value: user.client_id,
          text: user.company_name,
        };
        this.Code[index] = user.code;
        this.Code2[index] = user.code2;
        this.EmailAddress[index] = user.email;
        this.SSN[index] = user.ssn;
        this.Programs[index] = {
          value: user.program_id,
          text: user.program_name,
        };
        this.TransactionComment[index] = user.transaction_comments;
        this.EmailMessage[index] = user.email_msg;
        this.EmailSubject[index] = user.email_subject;
        this.JoiningDate[index] = user.joiningdate;
        this.BirthDay[index] = user.birthday;
        this.BirthYear[index] = user.birthyear;
      });

      console.log(userData, "from edit");
    },
  },

  mounted() {
    console.log(this.Companies);
    this.$store
      .dispatch("adminBatchUserUploadTool/fetchAllClientsProgram", {
        clientId: 0,
        status: "Active",
      })
      .then((data) => {
        console.log(data);
        this.clientAssociatedPrograms = data.reduce((prevVal, curVal) => {
          prevVal[curVal.clientId] = curVal.authorizedClientsPrograms.map(
            ({ programId, programName }) => ({
              text: programName,
              value: programId,
            })
          );
          return prevVal;
        }, {});
        console.log(this.clientAssociatedPrograms);
      });
  },

  created() {
    this.setActiveMenuItem();
    this.scrollToTop();
    this.$store.dispatch("adminPointPrograms/fetchAuthorizedClients");
    this.$store.dispatch("adminBatchUserUploadTool/fetchUsersForPreview", {
      operationType: "edit",
    });
  },
};
</script>

<style lang="scss" scoped>
.admin-batch-user-upload-tool {
  margin: -14px 0 0 0;
  .badge {
    font-size: 0.8rem;
    padding: 6px 0px;
    border-radius: $border-radius-sm;
  }
}
.align-right {
  text-align: right;
}

.bold-text {
  font-weight: bold;
}

.display-flex {
  display: flex;
}

.marginAll {
  margin: 10px;
}

.requiredFields {
  background: rgb(0, 204, 255);
}

.centered-spinner {
  position: fixed;
  top: 50%;
  left: 62%;
  transform: translate(-50%, -50%);
  z-index: 9999;
}

.disable {
  opacity: 0.5;
  pointer-events: none;
}
</style>
